var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountry6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 124,
    viewBox: "0 0 132 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_344_519",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 132,
    height: 124
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65625,
    width: 130.658,
    height: 124,
    rx: 33,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.15625,
    y: 0.5,
    width: 129.658,
    height: 123,
    rx: 32.5,
    stroke: "#1E417C",
    strokeOpacity: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_344_519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7969 -3.3291H112.253V127.329H19.7969V-3.3291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.9766 -3.3291H20.2385V127.329H-25.9766V-3.3291ZM112.694 -3.3291H158.909V127.329H112.694V-3.3291ZM34.0698 59.8051L30.4972 61.03L47.1867 75.7035C48.4626 79.4803 46.7528 80.5777 45.6555 82.5681L63.7741 80.2714L63.3147 98.5176L67.0915 98.39L66.2494 80.2969L84.419 82.4405C83.2962 80.0673 82.3009 78.8168 83.3217 75.04L100.011 61.1321L97.102 60.0858C94.7032 58.2229 98.1227 51.2052 98.6331 46.7649C98.6331 46.7649 88.9104 50.1079 88.2724 48.347L85.746 43.626L76.9164 53.3233C75.9467 53.5785 75.5384 53.1702 75.3087 52.3535L79.3917 32.0148L72.9099 35.6641C72.374 35.8937 71.8381 35.6641 71.4808 35.0516L65.2287 22.5473L58.7978 35.5365C58.313 35.9958 57.8281 36.0468 57.4198 35.7406L51.2442 32.27L54.9445 52.4811C54.6637 53.2467 53.9492 53.5019 53.1326 53.0681L44.6347 43.4219C43.5374 45.2082 42.7719 48.1174 41.3173 48.7809C39.8627 49.3678 34.9375 47.5304 31.6455 46.8159C32.7684 50.8734 36.29 57.6105 34.0698 59.8306V59.8051Z",
    fill: "#D52B1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry6);
export default __webpack_public_path__ + "static/media/country6.a32d0ce6278c550327c3797248d52c50.svg";
export { ForwardRef as ReactComponent };